import { Directive, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[appRestrictZero]',
    standalone: false
})
export class RestrictZeroDirective {
  @Input() restrictAlphaBet: boolean = false;
  @Input() allowOnlyNumber: boolean = true;
  @Input() restrictionApply: boolean = false;
  @Input() spaceAllow:boolean =true;
  constructor() { }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const inputChar = event.key;
    const input = event.target as HTMLInputElement;
    if (event.charCode === 32 && this.spaceAllow) {
      event.preventDefault();
    }
    
    if (this.restrictAlphaBet && !/[^A-Za-z]/.test(inputChar)) {
      event.preventDefault();
    }
    // // If first character: allow only 1-9
    if (this.allowOnlyNumber && input.value.length === 0 && !/^[1-9/.]/.test(inputChar)) {
      event.preventDefault();
    }
    // If not first character: allow only digits 0-9
    if (this.restrictionApply && input.value.length > 0 && !/^[0-9/.]/.test(inputChar)) {
      event.preventDefault();
    }

  }

}
